var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('itemCard',{attrs:{"type":"primary","data":_vm.computedData,"action":_vm.action,"actionText":_vm.actionText}})}
var staticRenderFns = []

export { render, staticRenderFns }